import React, { useCallback, useEffect, useState } from "react";
import { useSports } from "modules/sport/hooks";
import ImageBanner from "../../components/ImageBanner/ImageBanner";
import EventSlider from "../../components/EventSlider/EventSlider";
import { Content } from "./Content";
import { callApi } from "../../modules/core/api/services";
import { API_URL } from "modules/core/api/constants";
import { LoaderFullscreen } from "modules/core/components";
import { SPORT_ASSETS } from "modules/sport/constants";
import { Product } from "modules/payment/types";
import PricingSection from "../../components/PricingSection/PricingSection";
import { Pricing } from "pages/Static";

export const Home = () => {
  const { sports } = useSports();
  const [venues, setVenues] = useState<any[]>();
  const [products, setProducts] = useState<Product[]>();

  const getProducts = useCallback(async () => {
    const products = await callApi(
      `/v2/products?page=1&per_page=10&exclude_category=single_event_pass`
    );

    setProducts(products.data);
    return;
  }, [API_URL]);

  useEffect(() => {
    const fetchData = async () => {
      await getProducts();
    };

    fetchData();
  }, [getProducts]);

  const getVenues = useCallback(async () => {
    const venues = await callApi(`/v2/venues?page=1&per_page=10`);

    setVenues(venues.data);
    return;
  }, [API_URL]);

  useEffect(() => {
    const fetchData = async () => {
      await getVenues();
    };

    fetchData();
  }, [getVenues]);

  useEffect(() => {
    document.title = `Home | Staidium`;
  }, []);

  const events = [
    {
      name: "Knights Boulanger",
      league: "CNR",
      date: "01-11-2024",
      images: [
        {
          url: "/Staidium_Basketball.jpg"
        }
      ]
    },
    {
      name: "Chicago Blues",
      league: "CSDHL",
      date: "01-05-2024",
      images: [
        {
          url: "/Staidium_IceHockey.jpg"
        }
      ]
    },
    {
      name: "Legacy VTC Tournament",
      league: "High Performance",
      images: [
        {
          url: "/Staidium_Soccer.jpg"
        }
      ]
    },
    {
      name: "Phoenix Field",
      league: "ST. LOIUS HIERACHY 3",
      images: [
        {
          url: "/Staidium_Volleyball.jpg"
        }
      ]
    }
  ];

  if (!venues || !sports || !products) return <LoaderFullscreen />;

  return (
    <div id="home">
      <ImageBanner imgSrc={"/hero_basketball.jpg"} videoSrc="/STAIDIUM_BG_Video_compressed.mp4" carousel={true} />

      {sports.map((sport) => (
        <Content key={sport.uuid} sport={sport} />
      ))}

      <EventSlider
        title="STAIDIUM PARTNER"
        data={venues}
        type={"partner"}
        buttonText="See More"
      />

      <Pricing />

      <ImageBanner carousel={false} imgSrc={"/product/Gamepass.jpg"} />
    </div>
  );
};
